import AuthPage from "@/components/organisms/auth-page";
import { useI18n } from "@/i18n/use-i18n";
import { useRouter } from "next/router";

export default function LoginPage() {
  const { t } = useI18n();
  const router = useRouter();
  const requestedMode = Array.isArray(router.query.mode) ? router.query.mode[0] : router.query.mode;
  const initialMode = requestedMode === "signup" ? "signup" : "login";

  return <AuthPage key={initialMode} initialMode={initialMode} pageTitle={t("login.pageTitle")} />;
}
